/**
 * Drag rules for an outline tree, checked in the browser so an invalid drop never starts a request.
 *
 * The same rules the server enforces on both outlines: a line reorders only among sibling lines; a
 * task stays on its own line; a subtask may promote onto that line or reparent onto a root task of
 * it, and otherwise stays among the siblings of one parent.
 */
import { OutlineEntityKinds, OutlineRow } from '../outline.authoring.model';
import { isOutlineRootTask, isOutlineServiceLine, isOutlineSubtask, isOutlineTask } from '../outline.selection';

export function canDropOutlineRow(item: Partial<OutlineRow>, over: Partial<OutlineRow>, kinds: OutlineEntityKinds): boolean {

  if (isOutlineServiceLine(item, kinds)) return isOutlineServiceLine(over, kinds);
  if (!isOutlineTask(item, kinds)) return false;

  const itemLine = kinds.lineRef(item)?._id;
  const overLine = isOutlineServiceLine(over, kinds) ? over.sourceId : kinds.lineRef(over)?._id;
  if (!itemLine || itemLine !== overLine) return false;

  if (isOutlineSubtask(item, kinds)) {
    if (isOutlineServiceLine(over, kinds) || isOutlineRootTask(over, kinds)) return true;
    return !!item.parentId && item.parentId === over.parentId;
  }

  return isOutlineTask(over, kinds);
}
